import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import useAlerts from './useAlerts';

const { addAlert } = useAlerts();

const PICKLIST_ITEMS_MUTATION = gql`
  mutation deletePicklistItems($picklistitems: [ID]) {
    deletePicklistItems(picklistitems: $picklistitems)
  }
`;

export default function usePicklistItemsDelete() {
  const { mutate, loading, error } = useMutation(PICKLIST_ITEMS_MUTATION);

  async function deletePicklistItems(options) {
    try {
      const { data } = await mutate({ picklistitems: options });
      return data;
    } catch (error) {
      if (error.message.includes('Category is in use')) {
        addAlert('One or more categories are in use and cannot be deleted', 'high', 4);
        return;
      }

      console.error('Error deleting options:', error);
      addAlert('Error deleting options', 'high', 4);
    }
  }

  return {
    deletePicklistItems,
    loading,
    error,
  };
}
